import Moment from 'moment';

export default class Format {
  /**
   * Utility function that converts a date (in YYYY-MM-DDThh:mm:ss+00:00 format)
   * to MM/DD/YYYY h:mm AM/PM (or DD/MM/YYYY h:mm AM/PM depending on account
   * settings)
   *
   * @param {String} dateTime The unformatted date
   * @param {String} dateTimeFormat The Date Format in the account -
   *     either m/d/Y g:i a  or d/m/Y g:i a
   *
   * @return {String} The formatted date
   */
  static formatDateTime(dateTime, dateTimeFormat, includeTime) {
    let momentDateTimeFormat = 'MM/DD';
    if (dateTimeFormat.toLowerCase().includes('d/m/y')) {
      momentDateTimeFormat = 'DD/MM';
    }

    if (includeTime) momentDateTimeFormat += '/YYYY h:mm A';
    else momentDateTimeFormat += '/YYYY';

    return Moment(dateTime)
      .format(momentDateTimeFormat)
      .toString();
  }

  /**
   * Appends the correct currency symbol to a currency amount
   * and formats the amount
   *
   * @param amount
   * @returns {string} Currency Symbol followed by the Amount
   */
  static formatPrice(amount) {
    let ret = '';
    const floatAmount = parseFloat(amount);

    if (floatAmount < 0) {
      ret += '-';
    }

    ret += window.merchantos.locale.currency_symbol;
    ret += Math.abs(floatAmount).toFixed(2);

    return ret;
  }

  static toMoney(
    value,
    // eslint-disable-next-line camelcase
    currency = window?.merchantos?.locale?.currency_code ?? 'USD',
    localeCode = window?.merchantos?.locale?.lang ?? 'en-US'
  ) {
    const numberToCurrency = new Intl.NumberFormat(localeCode, {
      style: 'currency',
      currency,
    });

    const price = typeof value === 'string' ? parseFloat(value) : value;

    return numberToCurrency.format(price);
  }
}
